import jwtDecode from 'jwt-decode'
import { IJWTToken } from 'interfaces'

export const decodeToken = (token: string | undefined) => {
  let tokenDecoded: IJWTToken | undefined

  if (token !== '' && token !== undefined) {
    tokenDecoded = jwtDecode<IJWTToken>(token)
  }

  return {
    role: tokenDecoded ? tokenDecoded.authorities : undefined,
    username: tokenDecoded ? tokenDecoded.sub : undefined,
    expirationTime: tokenDecoded ? tokenDecoded.exp : undefined,
    centerId: tokenDecoded ? tokenDecoded.centerId : undefined,
  }
}
